import { mdiChartBarStacked } from '@mdi/js'

export default [
  {
    title: 'گزارش ها',
    icon: mdiChartBarStacked,
    action: 'can_see_report_menu',
    resource: 'all',
    children: [
      {
        title: ' تعداد پرداخت ها',
        to: 'report-payments',
        action: 'can_see_payament_count_report',
        resource: 'all',
      },
      {
        title: 'تعداد کاربران',
        to: 'report-users',
        action: 'can_see_user_count_report',
        resource: 'all',
      },
      {
        title: 'زمان تحویل',
        to: 'report-deliveries',
        action: 'can_see_deliver_time_report',
        resource: 'all',
      },
      {
        title: 'فعالیت های پشتیبانی',
        to: 'report-support',
        action: 'can_see_support_activity_report',
        resource: 'all',
      },
      {
        title: 'گزارش سالانه',
        to: 'report-yearly',
        action: 'can_see_yearly_report',
        resource: 'all',
      },
      {
        title: 'گزارش تیکت ها',
        to: 'report-tickets',
        action: 'can_see_ticket_report',
        resource: 'all',
      },
      {
        title: 'گزارش تماس ها',
        to: 'report-calls',
        action: 'can_see_call_report',
        resource: 'all',
      },
    ],
  },
]
